// @flow
import * as React from 'react';
import { IntlShape, defineMessages, injectIntl } from 'react-intl';
import BaseEditor from 'esm-web-pro/containers/map/editor/BaseEditor';
import Point12WithCables from 'esm-web-pro/containers/pages/network/objects/point11/Point12WithCables';
import RowActions from 'esm-web-pro/components/layout/sidePanel/RowActions';
import MeatballsIcon from 'esm-web-pro/components/layout/sidePanel/icons/MeatballsIcon';
import actionMessages from 'esm-web-pro/messages/actionMessages';
import { withRouter } from 'react-router';
import type { RouterHistory, Match } from 'react-router';
import { sortBy } from 'lodash';
import ValueText from 'esm-web-pro/components/layout/sidePanel/ValueText';
import ContentRow from 'esm-web-pro/components/layout/sidePanel/ContentRow';

type Props = {
    points12: Object,
    point11: Object,
    reserves: Object,
    intl: IntlShape,
    onDisconnectCable: Function,
    onClick: Function,
    mapIsDraft: boolean,
    editor: BaseEditor,
    onPoint11View: Function,
    clicked: ?string,
    setClicked: Function,
    history: RouterHistory,
    match: Match,
};

const msg = defineMessages({
    rack: {
        id: 'rack',
        defaultMessage: 'Rack {id}',
    },
});

const PoPContent = (props: Props) => {
    const {
        points12: ODFs, intl: { formatMessage }, point11, history, match, ...rest
    } = props;
    const { empty_racks: emptyRacks } = point11;

    const racks = {};
    Object.values(ODFs).forEach((ODF: Object) => {
        if (racks[ODF.rack.sequence]) {
            racks[ODF.rack.sequence].push(ODF);
        } else {
            racks[ODF.rack.sequence] = [ODF];
        }
    });

    const getRackActions = (rack) => [
        {
            key: `rack-${rack.id}-more`,
            icon: <MeatballsIcon />,
            size: '20px',
            width: '3px',
            callback: (e: SyntheticMouseEvent<HTMLButtonElement>) => {
                e.stopPropagation();
                const path = match.url.split('/layer');
                history.push(`${path[0]}/layer/rack/${rack.identity}`);
            },
            tooltip: formatMessage(actionMessages.more),
        },
    ];

    return (
        <React.Fragment key={`pop-content-${point11.id}`}>
            {Object.keys(racks).map<React.Node>((key: string) => {
                const sortedObjects = sortBy(racks[key], ['type', 'sequence']);
                return (
                    <React.Fragment key={`pop-container-${key}`}>
                        <ContentRow
                            actions={<RowActions actions={getRackActions(racks[key][0].rack)} />}
                            padLevel={1}
                        >
                            <ValueText>
                                {formatMessage(msg.rack, { id: key })}
                            </ValueText>
                        </ContentRow>
                        {sortedObjects.map((odf) => (
                            <Point12WithCables
                                key={`point12-${key}-${odf.id}-cables`}
                                point={odf}
                                point11={point11}
                                {...rest}
                            />
                        ))}
                    </React.Fragment>
                );
            })}
            {emptyRacks.map((rack) => (
                <ContentRow
                    actions={<RowActions actions={getRackActions(rack)} />}
                    padLevel={1}
                    key={rack.uuid}
                >
                    <ValueText>
                        {formatMessage(msg.rack, { id: rack.sequence })}
                    </ValueText>
                </ContentRow>
            ))}
        </React.Fragment>
    );
};

export default withRouter(injectIntl(PoPContent));
